import styles from "./Search.module.css"
import {useContext} from "react";
import {Context} from "../../../../../index";

function Search({provider_cur,filter_list_provders,filter_list_games, type, setVisiableBlockProviders,}) {
    const {store} = useContext(Context)
    if (type === "provider") {
        return (
            <div className={`${styles.searchWrapper} active`} onFocus={() => {

                setVisiableBlockProviders(true)
            }}>
                <input onChange={(e) => {

                    filter_list_provders(e.target.value)
                }} autoComplete="on" list="suggestions" type="text" className={styles.input}
                       placeholder={provider_cur==="all_providers_name"?store.dataLang["all_providers_name"]:provider_cur}/>
            </div>
        )
    } else {
        return (
            <div className={`${styles.searchWrapper} active`}>
                <input onChange={async(e) => {
                    filter_list_games(e.target.value)
                }} autoComplete="on" list="suggestions" type="text" className={styles.input}
                       placeholder={store.dataLang["enter_name_game"]}/>
            </div>
        )
    }

}

export default Search